import {InventoryFeature, ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import getConfig from 'getConfig';
import {ParameterType} from 'insights/parameters/ParameterTypes';

export default function isParameterTypeEnabled(parameterType: ParameterType): boolean {
  switch (parameterType) {
    case ParameterType.PROCESS_LINK:
    case ParameterType.PROCESS_TASK_LINK:
      return isFeatureEnabled({feature: ProcessesFeature.PROCESSES_DISCOVER});
    case ParameterType.STORABLE_LINK:
      return isFeatureEnabled({feature: InventoryFeature.INVENTORY_DISCOVER});
    case ParameterType.TEAM_LINK:
      return getConfig('ENABLE_TEAMS');
    default:
      return true;
  }
}
